const clearAdvertiserState = (state) => {
  localStorage.removeItem('l');
  state.advertisers = [];
  state.advertiser = null;
  state.advertiser_id = NaN;
}

const setAdvertiser = (state, newAdvertiser) => {
  localStorage.setItem('l', newAdvertiser.id);
  state.advertiser = newAdvertiser;
};

const updateAdvertiser = (state, payload) => {
  if (payload.company_name) {
    state.advertiser.name = payload.company_name;
  }
  state.advertiser.description = payload.company_description;
  state.advertiser.website_url = payload.website_url;
  state.advertiser.address = payload.address;
}

const hideRewardGuideLink = (state) => {
  state.advertiser.has_hid_reward_guide_link = true;
}

const setAdvertiserCounts = (state, payload) => {
  for (var i = 0; i < state.advertisers.length; i++) {
    if (state.advertisers[i].id === payload.id) {
      state.advertisers[i].counts = payload.counts
    }
  }
}

const addAdvertiser = (state, newAdvertiser) => {
  state.advertisers.push(newAdvertiser);
}

export default {
  clearAdvertiserState,
  setAdvertiser,
  updateAdvertiser,
  hideRewardGuideLink,
  setAdvertiserCounts,
  addAdvertiser,
}